import { Analytics } from './analytics';
import { MyCatalogRegisterAction } from '../my_catalog_register/my_catalog_register_action';

export class MyCatalogRegisterAnalytics extends Analytics {
  constructor() {
    super();
    MyCatalogRegisterAction.MY_CATALOG_REGISTER_EVENT.on((data) => {
      this.run(() => {
        const item = data.analyticsData.items[0];
        const productName = item.getProductName();
        const medicalMaterialType = item.getMedicalMaterialType();
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'お気に入りへ登録',
          events: ['event3'],
          items: [this.items(productName, medicalMaterialType)],
          club: {
            server: 'club/pc',
            prop5: 'お気に入りへ登録',
            events: ['event3'],
            products: [this.products(item._catalogItemCode, medicalMaterialType)]
          },
          soloel: {
            server: 'soloel/pc',
            prop5: 'お気に入りへ登録',
            events: ['event3'],
            products: [this.productsSoloel(item.getProductNameForSoloel())]
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }

  private items(productName: string, evars: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: this.medicalMaterialType(evars)
    };
  }

  private products(productName: string, evars: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: this.eVar79(evars)
    };
  }

  private productsSoloel(productName: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: {}
    };
  }

  private medicalMaterialType(evars: string) {
    return { medicalMaterialType: evars };
  }

  private eVar79(evars: string) {
    return { eVar79: evars };
  }
}
